const getActiveTab = mainForm => {
	if (mainForm && mainForm.dataset.tab) {
		return mainForm.dataset.tab;
	}
};

export default getActiveTab;
